/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useContext } from 'react'
import { SideNavContext } from './SideNavContext'

export const useSideNavContext = () => {
  const context = useContext(SideNavContext)
  if (!context) {
    throw new Error('useSideNavContext must be used within a SideNavState provider')
  }
  return context
}
